// extracted by mini-css-extract-plugin
export default {"container":"styles__container___Yz+Wc","menuItem":"styles__menuItem___EgJ69","text":"styles__text___WVy6Z","count":"styles__count___ox3-W"};